<template>
  <div class="flex-center media operator">
    <div v-if="imgSrc" class="pull-left flex-center">
      <img class="img_user_avatar js-tooltip" :title="fullname" :src="imgSrc" :alt="fullname" :data-original-title="fullname" />
    </div>
    <div class="media-body" style="font-size: 85%">
      <div>
        <div class="text-uppercase">{{ fullname }}</div>
        <span v-if="job">({{ job }})</span>
      </div>
      <div>
        <span v-if="labelDatetime">{{ labelDatetime }}</span
        >{{ date }}
        <span style="font-size: 85%">{{ time }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'userMedia',
  props: ['fullname', 'datetime', 'img', 'job', 'labelDatetime'],
  computed: {
    i18nJS() {
      return window.i18nJS;
    },
    date() {
      return this.datetime && this.datetime.split(' ')[0];
    },
    imgSrc() {
      if (this.img === false) {
        return false;
      }
      return this.img ? this.img : window.config.assets.images.missing_user;
    },
    time() {
      return this.datetime && this.datetime.split(' ')[1];
    },
  },
};
</script>

<style lang="scss" scoped>
.flex-center {
  display: flex;
  align-items: center;
}
</style>
